import { IDeleteProjetoArquivoUseCase } from "../../../presentation/useCases/delete/delete_projeto_arquivo_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";


export class DeleteProjetoArquivoUseCase implements IDeleteProjetoArquivoUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async deleteProjetoArquivo(IdProjetoArquivo: number): Promise<void> {
    return await this.repository.deleteProjetoArquivo(IdProjetoArquivo);
  }
}
